import { render, staticRenderFns } from "./ModalReactivarProductos.vue?vue&type=template&id=1fd3b16d"
import script from "./ModalReactivarProductos.vue?vue&type=script&lang=js"
export * from "./ModalReactivarProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports